module.exports = __webpack_public_path__ + "static/media/timer-bold.78ff2c0c.png";